import { IZonesUseOccupation } from "../../../../shared/interfaces/IZonesUseOccupation";

export default (form: Partial<IZonesUseOccupation>) => {
    const parsedForm: Partial<IZonesUseOccupation> = {
        ...form,
    };

    return parsedForm;
};
